import { useCallback, useEffect, useRef, useState } from 'react'

const SCROLL_TOP_OFFSET = 12

export const useModalScroll = (selectedCardId: string | null, isOpen: boolean) => {
  const [focusedCardId, setFocusedCardId] = useState<string | null>(null)
  const cardRefs = useRef<Record<string, HTMLDivElement | null>>({})
  const scrollAreaRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (isOpen && selectedCardId) {
      setFocusedCardId(selectedCardId)
    } else {
      setFocusedCardId(null)
    }
  }, [isOpen, selectedCardId])

  useEffect(() => {
    if (!focusedCardId) return
    const timer = setTimeout(() => {
      const el = cardRefs.current[focusedCardId]
      const container = scrollAreaRef.current
      if (el && container) {
        const elRect = el.getBoundingClientRect()
        const containerRect = container.getBoundingClientRect()
        const nextScrollTop =
          container.scrollTop + elRect.top - containerRect.top - SCROLL_TOP_OFFSET
        container.scrollTo({
          top: Math.max(0, nextScrollTop),
          behavior: 'smooth',
        })
      }
    }, 50)
    return () => clearTimeout(timer)
  }, [focusedCardId])

  const handleCardClick = useCallback((cardId: string) => {
    setFocusedCardId(cardId)
  }, [])

  return { focusedCardId, cardRefs, scrollAreaRef, handleCardClick }
}
